// Dropdown.tsx
import React, { useState, useRef, useEffect } from "react";
import { MdArrowDropDown } from "react-icons/md";
import { useAssetContext } from "../../DataContext/AssetContext";

const measuresList = ["Estimated Settlements", "Megawatt Delta", "Megawatts", "Price"];
const defaultSelected = ["Estimated Settlements", "Megawatt Delta"];

const Dropdown: React.FC = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const { selectedMeasures, setSelectedMeasures } = useAssetContext();

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = event.target;
    setSelectedMeasures(
      checked
        ? [...selectedMeasures, value]
        : selectedMeasures.filter((m) => m !== value)
    );
  };

  // Set default selection only on first render
  useEffect(() => {
    if (selectedMeasures.length === 0) {
      setSelectedMeasures(defaultSelected);
    }
  }, [selectedMeasures, setSelectedMeasures]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative w-full sm:w-60" ref={dropdownRef}>
      <div className="border rounded-md px-4 py-2 bg-white cursor-pointer" onClick={toggleDropdown}>
        <div className="text-gray-600 flex justify-between items-center text-xs sm:text-sm">
          <span>Measures</span>
          <MdArrowDropDown className="text-gray-600 text-xl" />
        </div>
        <div className="flex flex-wrap gap-1 mt-1">
          {selectedMeasures.map((measure, index) => (
            <span key={index} className="text-[10px] lg:text-xs text-red-500">{measure}</span>
          ))}
        </div>
      </div>
      {dropdownOpen && (
        <div className="absolute w-full bg-white shadow-lg z-50 max-h-60 overflow-y-auto mt-1">
          <div className="p-4">
            {measuresList.map(measure => (
              <label key={measure} className="block text-gray-700 text-xs sm:text-sm">
                <input
                  type="checkbox"
                  value={measure}
                  checked={selectedMeasures.includes(measure)}
                  onChange={handleCheckboxChange}
                  className="mr-2 accent-red-500"
                />
                {measure}
              </label>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Dropdown;